module.exports = __webpack_public_path__ + "static/img/afsc_icon.6bdc860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/afsc_icon.png
// module id = i3KT
// module chunks = 1